import gql from 'graphql-tag';
import { companyFieldsFragment, sanityDocumentFieldsFragment } from '@graphql/admin/fragments';

export const addCompanyMutation = gql`
  mutation AddCompany($input: CreateCompanyInput!) {
    addCompany(input: $input) {
      ...AdminSanityDocumentFields
      ...AdminCompanyFields
    }
  }

  ${sanityDocumentFieldsFragment}
  ${companyFieldsFragment}
`;